<template>
  <div class="report-generator">
    <div id="report">
      <div class="primary-cost-container">
        <div class="page-break-after">
          <h1>PRIMARY COST ESTIMATE</h1>
          <p>This is a calculation of materials, plant and labour for estimating purposes only (not a fixed price
            model).</p>
          <address>
            <p>Mr and Mrs Sample</p>
            <p>Sample Address</p>
            <p>Sample Street</p>
            <p>AB12 3CD</p>
          </address>
          <p>Date: 13/09/23</p>
          <p>Code: 2309-1310-2601</p>
          <p>Call: 01359 256311</p>
        </div>
        <div class="page-break-after">
          <div>The is estimate is based on the information provided
            and the responsibility is solely with you as the
            customer to ensure the correct information is inputted.
          </div>
          <div>Project Reference: 2309-1310-260</div>
          <div>
            <div>
              PRIMARY COST ESTIMATE SUMMARY
            </div>
            <div>
              <div>
                <div>Completion of Oversite</div>
                <div>£29,665.79</div>
              </div>
              <div>Included Work Sections: Site Setup, Foundations,
                Ground Floor, Drainage, Laying Of Services
              </div>
            </div>
            <div>
              <div>
                <div>Completion of Wallplate</div>
                <div>£41,327.63</div>
              </div>
              <div>
                Included Work Sections: Walls, Scaffolding,
                Windows & Doors, Lintels, Steelwork, Upper Floors
              </div>
            </div>
            <div>
              <div>
                <div>Completion of Roof</div>
                <div>£13,717.06</div>
              </div>
              <div>
                Included Work Sections: Roof, Guttering
              </div>
            </div>
            <div>
              <div>
                <div>Completion of Plastering</div>
                <div>£13,717.06</div>
              </div>
              <div>
                Included Work Sections: 1st Fix Carpentry, 2nd Fix
                Carpentry, Plastering, Alterations, Plumbing,
                Electrics, Fixing Summary
              </div>
            </div>
            <div>
              <div>
                <div>Completion of Contract</div>
                <div>£13,717.06</div>
              </div>
              <div>
                Included Work Sections: Finishes, Decorating,
                Professional Services, Other Provisional Sums
              </div>
            </div>
            <div>
              Total Estimated Costs £138,012.74
            </div>
            <div>
              Client Total (Ex. VAT) £151,814.01
            </div>
          </div>
          <div>
            <div>Options Selected:</div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <b-button @click="generatePDF">Generate PDF</b-button>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import filters from "../../../../../resource/module/filters";

export default {
  name: "report-generator",
  filters,
  props: {
    buildStages: {
      type: Array,
      required: true,
    },
    totalWithoutVAT: {
      type: Number,
      required: true
    },
    pcSums: {
      type: Array,
      required: true
    },
  },
  data() {
    return {};
  },
  watch: {
    buildStages: {
      immediate: true,
      handler(newValue) {
        if (!Array.isArray(newValue) || newValue.length === 0) {
          this.showErrorToast('Invalid data format!');
          this.$router.back();
          return;
        }

        for (const stage of newValue) {
          if (typeof stage.name !== 'string' || typeof stage.value !== 'number') {
            this.showErrorToast('Invalid data in build stages!');
            this.$router.back();
            return;
          }
        }
      }
    }
  },
  computed: {
    builderName() {
      return this.$store.getters["user/loggedInUser"].name;
    },
    contactEmail() {
      return this.$store.getters["user/loggedInUser"].email;
    },
    contactNumber() {
      return this.$store.getters["user/loggedInUser"].telephone;
    }
  },
  methods: {
    generatePDF() {
      const element = document.getElementById("report");
      const opt = {
        margin: 0.1,
        filename: "report.pdf",
        image: {type: "jpeg", quality: 0.98},
        html2canvas: {scale: 2},
        jsPDF: {unit: "in", format: "letter", orientation: "portrait"}
      };
      html2pdf().set(opt).from(element).save();
    },
    showErrorToast(message) {
      this.$buefy.toast.open({
        duration: 5000,
        message: message,
        type: 'is-danger',
        pauseOnHover: true,
        dismissible: true
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.report-generator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: $white;

  #report {
    width: 100%;
    max-width: 800px;
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;

    .table td:nth-child(1) {
      width: 70%; /* Adjust as needed */
      max-width: 70%;
    }

    .table th:nth-child(2),
    .table td:nth-child(2) {
      width: 350px;
      max-width: 350px;
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .page-break-after {
    page-break-after: always;
  }
}
</style>